import React, { PureComponent } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { MODAL_CONFIRM_DISCARD_CHANGES } from '../constants/constants';
import {
  createCase,
  displayWrapper,
  casePartSelect,
  showConfirmModal,
  flagGeneral,
  flagCaseLevel,
  flagSpecimen,
  specimenSelect,
  refreshSeadragon,
  forceFormRefresh,
  setCadessOverlay,
} from '../redux/actions';
import { InboxListValidation } from '../components';
import Chevron from '../assets/images/chevron.svg';
import moment from 'moment';


class InboxValidation extends PureComponent {
  addListenerToWindow = () => {
    window.onbeforeunload = () => {
      if (this.checkIfChangesHasBeenMade()) {
        return true;
      }
    };
  };

  constructor(props) {
    super(props);

    this.state = {
      searchValue: '',
      sortValue: 3,
      specimens: [],
      inboxExpandedClassName: 'validation__sidebar',
      inboxExpandedButton: 'validation__sidebar__button-collapse',
      inboxCollapsedClassName: 'validation__sidebar__collapsed-hidden',
      inboxContainerClassName:'',  
      displayArchived: false,
      forceReRender: true,
    };

    this.addListenerToWindow();
  }

  componentDidUpdate() {
    if (this.props.displayWrapper === true) {
      this.props.displayWrapper();
    }
  }

  handleSpecimenSelected = (specimen) => {
    // we dont need to reload selectedCase
    if (specimen._id === this.props.selectedSpecimen._id) return;

    if (this.props.selectedSpecimen._id) {
      const changesHasBeenMade = this.checkIfChangesHasBeenMade();
      if (changesHasBeenMade) {
        this.props.showConfirmModal(MODAL_CONFIRM_DISCARD_CHANGES, {
          onConfirm: () => {
            this.selectSpecimen(specimen);
          },
        });
      } else {
        this.selectSpecimen(specimen);
      }
    } else {
      this.selectSpecimen(specimen);
    }
  };

  selectSpecimen = (specimen) => {
    this.props.specimenSelect(specimen);
    this.props.refreshSeadragon();
    this.props.forceFormRefresh();
    this.props.displayWrapper();
    setTimeout(() => {
      this.props.displayWrapper();
    }, 100);
  };


//Changes the className to handle the collapse animation of the inbox. 
//The styling can be found in _sidebar.scss
  //collapses sidebar
  handleCollapse = () =>{
    if(this.state.inboxExpandedClassName === 'validation__sidebar'){
      this.setState({
        inboxExpandedClassName: 'validation__sidebar-hidden',
        inboxExpandedButton: 'validation__sidebar__button-collapse-hidden',
        inboxCollapsedClassName: 'validation__sidebar__collapsed',
        inboxContainerClassName: 'validation__sidebar__collapse-container',
      });
      this.props.handleMainCollapse(); //changes the class on main
    }
    //Expands sidebar
    else{
      this.setState({
        inboxExpandedClassName: 'validation__sidebar',
        inboxExpandedButton: 'validation__sidebar__button-collapse',
        inboxCollapsedClassName: 'validation__sidebar__collapsed-hidden',
        inboxContainerClassName:'',
      });
      this.props.handleMainCollapse(); //changes the class on main
    }
  };


  checkIfChangesHasBeenMade = () => {
    const forms = Object.values(this.props.form);

    let changesHaveBeenMade;

    const newlyAddedValuesButNoInitial = forms.some((item) =>
      (item.values && !item.initial));

    const valuesExistedAndAreChanged = forms
      .filter((item) => item.values && item.initial)
      .some((item) => !_.isEqual(item.values, item.initial));

    if (newlyAddedValuesButNoInitial || valuesExistedAndAreChanged) {
      changesHaveBeenMade = true;
    }

    this.props.specimens.forEach((specimen) => {
      specimen.analyses.forEach((analysis) =>
        (analysis.hasUnsavedChanges ? (changesHaveBeenMade = true) : null));
    });

    return changesHaveBeenMade;
  };

  render() {


    const{
      handleMainCollapse,
    } = this.props;
    const submitted = [];
    const notSubmitted = [];
    this.props.specimens.forEach((specimen) => {
      specimen.analyses[0].validationComplete
        ? submitted.push(specimen)
        : notSubmitted.push(specimen);
    });

    // Sorts submitted specimens by time submitted
    submitted.sort((a, b) => {
      const momentA = moment(a.analyses[0].analysisUpdatedAt);
      const momentB = moment(b.analyses[0].analysisUpdatedAt);
      return momentB - momentA
    });

    const numberOfSubmittedSpecimen = submitted.length;
    const numberOfNotSubmittedSpecimen = notSubmitted.length;
    const totalNumberOfSpecimen = numberOfNotSubmittedSpecimen + numberOfSubmittedSpecimen;


      return (
        <React.Fragment>
          <div className={this.state.inboxExpandedClassName}>
            <InboxListValidation
              specimenArray={this.props.specimens}
              notSubmitted={notSubmitted}
              submitted={submitted}
              numberOfSubmittedSpecimen={numberOfSubmittedSpecimen}
              numberOfNotSubmittedSpecimen={numberOfNotSubmittedSpecimen}
              totalNumberOfSpecimen={totalNumberOfSpecimen}
              selectedSpecimenId={this.props.selectedSpecimen._id}
              handleSpecimenSelected={this.handleSpecimenSelected}
              handleCollapse = {this.handleCollapse}
              handleMainCollapse = {handleMainCollapse}
            />
          </div>
  
          <div className={this.state.inboxExpandedButton} onClick={() => {this.handleCollapse(); handleMainCollapse();}}>
             <img src={Chevron} className="sidebar__button-collapse-icon" alt="Collapse menu" />
          </div>

          <div className={this.state.inboxCollapsedClassName} onClick={() => {this.handleCollapse(); handleMainCollapse();}}>
            <div className="validation__sidebar__collapsed-specimen-number">
                {numberOfSubmittedSpecimen} of {totalNumberOfSpecimen} Specimen Submitted
            </div>
              <img src={Chevron} className="sidebar__collapsed-icon" alt="Expand menu" />
          </div>

        </React.Fragment>
      );
    }
   }



const mapStateToProps = ({ _case, form, auth }) => {
  const {
    caseClicked,
    specimens,
    casePartSelected,
    selectedSpecimen,
  } = _case;
  const { user } = auth;
  return {
    user,
    userId: user.userId,
    form,
    caseClicked,
    specimens,
    casePartSelected,
    selectedSpecimen,
    _case,
  };
};

export default connect(
  mapStateToProps,
  {
    forceFormRefresh,
    refreshSeadragon,
    createCase,
    displayWrapper,
    casePartSelect,
    showConfirmModal,
    flagGeneral,
    flagCaseLevel,
    flagSpecimen,
    specimenSelect,
    setCadessOverlay,
  },
)(InboxValidation);
